import { GrowthBook } from "@growthbook/growthbook-react";
import { growthbookExperimentJoined } from "utils/segment";

// Create a GrowthBook instance
export const growthbook = new GrowthBook({
  // The attributes you want to use to assign variations
  user: {
    id: localStorage.getItem("accountID") || localStorage.getItem("ajs_anonymous_id") ? localStorage.getItem("ajs_anonymous_id").replace('"', "") : null,
  },
  // Called every time the user is put into an experiment
  trackingCallback: (experiment, result) => {
    // Mixpanel, Segment, GA, or custom tracking
    growthbookExperimentJoined(experiment, result)
  },
});
